<template>
  <FourElement></FourElement>
  <div class="collection-container">
    <Filter></Filter>
    <List></List>
    <AddModal></AddModal>
  </div>
</template>

<script>
import FourElement from './components/FourElement.vue'
import List from './components/List.vue'
import AddModal from './components/AddModal.vue'
import Filter from './components/Filter.vue'
import { toRefs, reactive, provide, onMounted } from 'vue'
import {
  queryPageTaskCategory,
  addTaskCategory,
  updateTaskCategory,
  deleteTaskCategory
} from 'server/modules/task'
import useAPI from 'UseApi'
const { common_querySiteInfo_get_ } = useAPI(null, [3426])
import { common_lang_get } from 'server/modules/3426'
import { message } from 'ant-design-vue'
// import { message } from 'ant-design-vue'
export default {
  components: {
    FourElement,
    List,
    Filter,
    AddModal
  },
  setup() {
    const state = reactive({
      searchParams: {
        terminalId: 1,
        brandId: 1,
        channelId: 1,
        siteId: 1
      },
      pagination: {
        current: 1, //默认的当前页数
        pageSize: 10, //每页显示几条数据
        total: 0,
        onChange: (current, pageSize) => {
          state.pagination.current = current
          state.pagination.pageSize = pageSize
          state.getTabList()
        }
      },
      //表格数据
      dataSource: [],
      brands: [],
      channels: [],
      sites: [],
      //语言数据
      langList: [],
      //0新增 1编辑 2详情
      modalType: 0,
      //列
      columns: [
        {
          title: '序号',
          align: 'center',
          dataIndex: 'taskCategoryId',
          key: 'taskCategoryId'
        },
        {
          title: '名称',
          dataIndex: 'taskCategoryName',
          key: 'taskCategoryName',
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operate',
          align: 'center'
        }
      ],
      //筛选
      filterData: {},
      //重置筛选
      resetFilter: () => {
        state.filterData = {}
        state.initList()
      },
      initList: () => {
        state.getTabList()
        state.initCommonLang()
      },
      //table数据
      getTabList: () => {
        const param = {
          pageNum: state.pagination.current,
          pageSize: state.pagination.pageSize
        }
        queryPageTaskCategory(param)
          .then(e => {
            if (e.success) {
              state.dataSource = e.data.data.list.records
              state.pagination.total = e.data.data.total
            }
          })
          .catch(err => {
            console.log('err: ', err)
          })
      },
      initCommonLang: async () => {
        const { data } = await common_lang_get(state.searchParams)
        state.langList = Object.entries(data.languageMap).map(
          ([key, value]) => ({
            label: key,
            value
          })
        )
      },
      modalVisible: false,
      formRef: null,
      form: {
        // taskCategoryName: [
        //   {
        //     key: undefined,
        //     value: undefined
        //   }
        // ]
      },
      editType: '',
      //校验
      rules: {
        taskCategoryName: [{ required: true, message: '请输入名称！' }]
      },
      add: type => {
        state.editType = 1
        state.modalType = type
        state.modalVisible = true
      },
      modalCancel: () => {
        state.formRef.clearValidate()
        state.form = {
          // taskCategoryName: [
          //   {
          //     key: undefined,
          //     value: undefined
          //   }
          // ]
        }
        state.modalVisible = false
      },
      // addNameContent() {
      //   state.form.taskCategoryName.push({
      //     key: undefined,
      //     value: undefined
      //   })
      //   console.log(state.form.taskCategoryName)
      // },
      // removeNameContent: info => {
      //   if (state.form.taskCategoryName.length > 1) {
      //     const index = state.form.taskCategoryName.indexOf(info)
      //     if (index !== -1) {
      //       state.form.taskCategoryName.splice(index, 1)
      //     }
      //   }
      // },
      modalSubmit: async () => {
        state.formRef
          .validateFields()
          .then(() => {
            // alert(JSON.stringify(state.form))
            // return false
            const param = {
              ...state.form
            }
            // param.taskCategoryName = JSON.stringify(param.taskCategoryName)
            if (param.taskCategoryId) {
              updateTaskCategory(param)
                .then(e => {
                  if (e.success) {
                    if (e.data.succes) {
                      message.success('更新成功')
                      state.formRef.clearValidate()
                      state.form = {
                        // taskCategoryName: [
                        //   {
                        //     key: undefined,
                        //     value: undefined
                        //   }
                        // ]
                      }
                      state.modalVisible = false
                      state.initList()
                    } else {
                      message.warning(e.data.data)
                    }
                  } else {
                    message.warning(e.data)
                  }
                })
                .catch(err => {
                  console.log('err: ', err)
                  message.warning(err.retInfo)
                })
            } else {
              addTaskCategory(param)
                .then(e => {
                  if (e.success) {
                    if (e.data.succes) {
                      message.success('添加成功')
                      state.formRef.clearValidate()
                      state.form = {
                        // taskCategoryName: [
                        //   {
                        //     key: undefined,
                        //     value: undefined
                        //   }
                        // ]
                      }
                      state.modalVisible = false
                      state.initList()
                    } else {
                      message.warning(e.data.data)
                    }
                  } else {
                    message.warning(e.retInfo)
                  }
                })
                .catch(err => {
                  console.log('err: ', err)
                  message.warning(err.retInfo)
                })
            }
          })
          .catch(e => {
            console.log('e: ', e)
          })
      },
      handleEdit: (type, info) => {
        if (info) {
          state.form = {
            ...info
            // taskCategoryName: JSON.parse(info.taskCategoryName)
          }
          state.editType = 2
          state.modalType = type
          state.modalVisible = true
        }
      },
      handleDel: info => {
        if (info) {
          deleteTaskCategory(info)
            .then(e => {
              if (e.success) {
                message.success('删除成功')
                state.initList()
              } else {
                message.warning(e.data)
              }
            })
            .catch(err => {
              console.log('err: ', err)
              message.warning(err.retInfo)
            })
        }
      }
    })
    onMounted(() => {
      common_querySiteInfo_get_({
        state
      })
      state.initList()
    })
    provide('initState', state)
    return {
      ...toRefs(state)
    }
  }
}
</script>

<style lang="scss" scoped>
.collection-container {
  margin: 20px;
  padding: 20px;
  overflow: hidden;
  background: #ffffff;
}
</style>
